import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoaderService } from 'app/services/loader.service';
import { PortfolioService } from '../../portfolio/portfolio.service';



@Component({
  selector: 'app-createapartment',
  templateUrl: './createapartment.component.html',
  styleUrls: ['./createapartment.component.css'],
  providers: [PortfolioService]
})
export class CreateapartmentComponent implements OnInit {
  public createApartmentForm: FormGroup;
  city_list: any;
  states: any;

  constructor(
    public router: Router,
    private formBuilder: FormBuilder,
    private portfolioService: PortfolioService,
    private loaderService : LoaderService

  ) { }

  ngOnInit() {
   
    
    this.getStates();
    this.getFilterData();
    this.getApartmentFormatData();
    this.CreateForm()

  }
  CreateForm(){
    this.createApartmentForm = this.formBuilder.group({
      pincode: new FormControl("", [Validators.required]),
      area_name: new FormControl("", [Validators.required]),
      city: new FormControl(null, [Validators.required]),
      state: new FormControl(null, [Validators.required]),
      cluster: new FormControl(""),
      apartment_name: new FormControl("", [Validators.required]),
      unid: new FormControl("", [Validators.required,Validators.minLength(15)]),
      apartment_address: new FormControl("", [Validators.required]),
      developer_name: new FormControl("", [Validators.required]),
      area: new FormControl("", [Validators.required]),
      apartment_value: new FormControl("", [Validators.required]),
      lifestage: new FormControl("", [Validators.required]),
      theme: new FormControl("", [Validators.required]),
      start_from: new FormControl(""),
      boq_emi: new FormControl(""),
      formats: this.formBuilder.array([this.createItem()])
    });
  }


  createItem(): FormGroup {
    return this.formBuilder.group({
      name: new FormControl("", [Validators.required]),
      variants: this.formBuilder.array([this.createVariantItem()]),
      // variant_id: new FormControl(""),
      // layout_image: new FormControl("")
    });
  }

  createVariantItem(): FormGroup {
    return this.formBuilder.group({
      variant_id: new FormControl("", [Validators.required]),
      layout_image: new FormControl("", [Validators.required]),
      primary_image: new FormControl("", [Validators.required]),
      layout_imgagefilename:new FormControl(null),
      primary_imagefilename:new FormControl(null),
      vr_link:new FormControl(""),
    });
  }

  pushJobAttributes(createApartmentForm) {
    
    return createApartmentForm.get('formats').push(this.createItem())
  }

  addAnotherVariant(item) {
    
    item.get("variants").push(this.createVariantItem());
  }

  back() {
    this.router.navigate(['/apartment/create']);
  }

  getStates() {
    this.portfolioService.getStateList().subscribe(res => {
      this.states = res.state_list;
    })
  }
  getscityList(id) {
    this.portfolioService.getApartmentCity(id).subscribe(res => {
      this.city_list = res.Cities[id];
    })
  }
  theme: any;
  lifeStage: any;
  getFilterData() {
    this.portfolioService.getFilterData().subscribe(
      res => {
        this.lifeStage = res.lifestage;
        this.theme = res.theme;
      }
    );
  }

  formatData: any;
  getApartmentFormatData() {
    this.portfolioService.getFormatData().subscribe(res => {
      this.formatData = res.format;
    })
  }

  attachment_file: any;
  basefile = [];
  basefile3 = [];
  layoutimg1 = [];
  layoutimg2 = [];
  layoutimg3 = [];
  layoutimg4 = [];
  onChange(event, i, j) {
    this.attachment_file = event.srcElement.files[0];
    console.log( this.attachment_file.name);
    (<HTMLInputElement>document.getElementById(`fileNamePreset${i}${j}`)).value = this.attachment_file.name
    // if((this.attachment_file.size/1024) > 120) {
    //   document.getElementById('errorsize'+i).innerHTML = 'File size should not exceed 120kb.';
    // }
  
    var sec_arr = this.createApartmentForm.get("formats") as FormArray;
    sec_arr.controls[i]["controls"]["variants"].controls[j].controls['layout_imgagefilename'].patchValue(this.attachment_file.name)

    var fileReader = new FileReader();
    fileReader.onload = (fileLoadedEvent) => {
      var base64;
      var image = new Image();
      image.src = fileReader.result;
      base64 = fileLoadedEvent.target;
      console.log("guijjj",base64.result)
      sec_arr.controls[i]["controls"]["variants"].controls[j].controls['layout_image'].patchValue(base64.result)
      this.basefile2 = base64.result
      this.layoutimg1.push(base64.result);
     
    };
      fileReader.readAsDataURL(this.attachment_file);
  }

  attachment_file2: any;
  basefile2 = [];
  basefile4 = [];
  primaryimg1 = [];
  primaryimg2 = [];
  primaryimg3 = [];
  primaryimg4 = [];
  onChangeImage(event, i, j) {
    this.attachment_file2 = event.srcElement.files[0];
    (<HTMLInputElement>document.getElementById(`fileNamePresetone${i}${j}`)).value = this.attachment_file2.name
    var sec_arr = this.createApartmentForm.get("formats") as FormArray;
    sec_arr.controls[i]["controls"]["variants"].controls[j].controls['primary_imagefilename'].patchValue(this.attachment_file2.name)
    var fileReader = new FileReader();

     
      fileReader.onload = (fileLoadedEvent) => {
        var base64;
        var image = new Image();
        image.src = fileReader.result;
        base64 = fileLoadedEvent.target;
        console.log("guijjj",base64.result)
        sec_arr.controls[i]["controls"]["variants"].controls[j].controls['primary_image'].patchValue(base64.result)
      };

   

   
    fileReader.readAsDataURL(this.attachment_file2);
    
    console.log(sec_arr);
  }


  transform(value: string): string {
    return value.replace(/_/g, ' ');
  }

  msgError: boolean = false;
  errorMessage: string;
  successError: boolean = false;
  successMessage: string;
  onSubmit(data) {
    window.scrollTo(0,0); 
    console.log("Create Apartement Data", data);
    var arr = this.basefile;
    var arr2 = this.basefile2;
    // For inserting Layput and rpimary img into 1 format 
    
    this.loaderService.display(true);
    this.portfolioService.createApartment(data).subscribe(res => {
      console.log(res);
    
      this.successMessage = "Apartment Added Successfully !!!";
      this.successMessageShow(this.successMessage);
      this.createApartmentForm.reset();
      this.CreateForm();
      this.loaderService.display(false);
      setTimeout(
        function () {
          this.router.navigateByUrl('/apartment/create');
        }.bind(this),
        2000
      );

     

     

    },

        error => {
          this.msgError = true;
          this.errorMessage = "OOPS!!! Something Went Wrong."
          this.errorMessageShow( this.errorMessage)
      this.loaderService.display(false);
        })
  }

  erroralert: any;
 
  successalert;
  
  errorMessageShow(msg) {
    this.msgError = true;
    this.errorMessage = msg;
    setTimeout(
      function () {
        this.msgError = false;
      }.bind(this),
      2000
    );
  }
  successMessageShow(msg) {
    this.successError = true;
    this.successMessage = msg;
    setTimeout(
      function () {
        this.successError  = false;
      }.bind(this),
      2000
    );
  }

 
}




// WEBPACK FOOTER //
// ./src/app/platform/organisation/add-apartment/createapartment/createapartment.component.ts